<template>
  <router-link
    class="nav-icon-group h-full justify-center flex flex-col items-center"
    :class="[customClasses, { active: isActive, mobile: isMobile }]"
    role="link"
    tabindex="0"
    :to="to"
  >
    <div class="relative">
      <Badge v-if="badgeNum > 0" :number="badgeNum" class="absolute left-12 -top-4 md:-top-6 md:ml-0 md:left-12" />
      <slot />
    </div>
    <p class="text-caption">{{ text }}</p>
  </router-link>
</template>

<script lang="ts">
import Badge from '../badge/Badge.vue';

export default {
  name: 'NavigationItem',
  components: {
    Badge,
  },
  props: {
    to: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    badgeNum: {
      type: Number,
      required: false,
      default: 0,
    },
    customClasses: {
      type: String,
      required: false,
      default: '',
    },
    isActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    isMobile: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-icon-group {
  &:focus {
    border: 2px dotted #bb0049;
    outline: none;
  }
  border: 2px solid var(--light-surface-foreground, #fff);
  width: 80px;
  &:hover {
    border-color: #f3f3f3;
    cursor: pointer;
    background-color: #f3f3f3;
    p {
      color: #bb0049;
    }
    span {
      color: #bb0049;
    }
    path {
      fill: #bb0049;
    }
  }
  &.active:not(:focus) {
    border-bottom: 2px solid var(--on-surface-headers, #05070f);
    &.mobile {
      border-top: 2px solid var(--on-surface-headers, #05070f);
      border-bottom: 2px solid #fff;
      &:focus {
        border-bottom: 2px dotted #bb0049;
      }
      &:hover {
        border-top-color: #bb0049;
        border-bottom-color: #f3f3f3;
      }
    }
    &:hover {
      border-bottom-color: #bb0049;
    }
  }
}
</style>
